import { useTranslation } from "react-i18next";

import type { SensorIcon } from "@map/logic";
import { cn } from "@utils";

// How busy the area's sensors say it is, as a coloured dot and a word. Without sensor data it shows nothing.
export const AreaOccupancyLabel = ({ status }: { status: SensorIcon }) => {
  const { t } = useTranslation();

  const labels: Record<Exclude<SensorIcon, "unknown">, string> = {
    full: t("translation:Full"),
    busy: t("translation:Busy"),
    lively: t("translation:Lively"),
    quiet: t("translation:Quiet"),
  };

  if (status === "unknown") return null;

  return (
    <span className="flex flex-none items-center gap-2 rounded-md border border-mapiq-black-150 px-1.5 py-0.5">
      <span
        className={cn("size-2 rounded", {
          "bg-functional-red": status === "full",
          "bg-creative-pink-500*": status === "busy",
          "bg-energizing-yellow-600": status === "lively",
          "bg-[#309A66]": status === "quiet",
        })}
      />
      <span className="text-[13px] font-semibold text-mapiq-black-500">{labels[status]}</span>
    </span>
  );
};
